import type { PetitionUpdate } from '#src/app/pages/petitionDetails/shared/types';

// Reuses the shared, petition-wide `petition_update_view` event (also emitted by the Signed Petition
// Home updates feed and the petition-update details page) instead of a bespoke event. The classic
// petition details page is the control surface for the SPH experiment, so its in-page updates feed
// emits the same event tagged with `view_context: petition_details` to keep the update-view funnel
// comparable with the SPH treatment (`view_context: signed_petition_home`).
export const PETITION_UPDATE_VIEW_EVENT = 'petition_update_view';

// `view_context` marking the classic petition details surface (matches the QR-code download event).
export const PETITION_DETAILS_VIEW_CONTEXT = 'petition_details';

/**
 * Returns the analytics `kind` for a real, trackable update view — or `null` when the update must
 * NOT fire the event. Mirrors the SPH `getSphUpdateTrackingKind` vocabulary so both experiment
 * surfaces count the same update kinds: only the real content updates (`starter`, `dmResponse`) are
 * tracked. Excluded are the synthetic creation/victory cards and signature milestones (as on SPH),
 * plus staff/featuredNews (not tracked on SPH, so kept out here too for a like-for-like comparison).
 * The value is the update's own `type` discriminant, matching the vocabulary the petition-update
 * events already report.
 */
export function getPetitionDetailsUpdateTrackingKind(update: PetitionUpdate): string | null {
	switch (update.type) {
		case 'starter':
		case 'dmResponse':
			return update.type;
		default:
			return null;
	}
}
